const name = '@ecomplus/utils'
const version = '1.5.0'

// exports info about the package
export default name + '@' + version
export { version }
